import { mergeRight, uniq, append, without } from 'ramda'
import { ActionTypes } from './actions'

const defaultState = {
  segments: [],
  filteredSegments: [],
  filteredSegmentType: 'ALL',
  selectedSegments: []
}

const segments = (state = defaultState, action) => {
  switch (action.type) {
    case ActionTypes.RECEIVE_SEGMENTS:
      return mergeRight(state, {
        segments: action.segments
      })

    case ActionTypes.FILTER_SEGMENT_TYPE:
      return mergeRight(state, {
        filteredSegmentType: action.filterByType
      })

    case ActionTypes.SELECT_SEGMENT:
      if (Array.isArray(action.selectedId)) {
        return mergeRight(state, {
          selectedSegments: uniq(action.selectedId)
        })
      } else {
        return mergeRight(state, {
          selectedSegments: uniq(append(action.selectedId, state.selectedSegments))
        })
      }

    case ActionTypes.DESELECT_SEGMENT:
      const removed = Array.isArray(action.deselectedId) ? action.deselectedId : [action.deselectedId]
      return mergeRight(state, {
        selectedSegments: without(removed, state.selectedSegments)
      })
    
    default:
      return state
  }
}

export default segments